export default "/images/star-search-hint.png?89d3aa57fc29c0fece802a755763998c";